/* ==========================================================================
   TUUFAM ADVANCED CINEMATIC HEADER ENGINE (SEARCH-SAFE)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initTaglineSwitcher();
  initCinematicEnvironment();
});

/* --- 1. CORE OVERRIDES (Managed in tuufam-header.css) --- */

/* --------------------------------------------------------------------------
   2. CINEMATIC PARTICLE ENGINE (Real Snow, Rain, Leaves, Fire)
   -------------------------------------------------------------------------- */
function initCinematicEnvironment() {
  const headerWrapper = document.querySelector('.tuufam-header-wrapper');
  if (!headerWrapper) return;

  // Inject Canvas safely at the absolute bottom of the DOM stack 
  // This physically renders it behind the UI without breaking absolute search modals
  const canvas = document.createElement('canvas');
  canvas.style.position = 'absolute';
  canvas.style.top = '0';
  canvas.style.left = '0';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none'; // Clicks pass right through it
  headerWrapper.insertBefore(canvas, headerWrapper.firstChild);

  const ctx = canvas.getContext('2d');
  let particles = [];
  
  // High-End Physics Cycle
  const seasons = ['snow', 'rain', 'autumn', 'fire'];
  let currentSeasonIndex = 0;
  let activeSeason = seasons[currentSeasonIndex];

  function resize() {
    canvas.width = headerWrapper.offsetWidth;
    canvas.height = headerWrapper.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  class CinematicParticle {
    constructor() {
      this.reset(true);
    }

    reset(initial = false) {
      this.x = Math.random() * canvas.width;
      this.z = Math.random() * 1.5 + 0.5; // Depth of field

      if (activeSeason === 'snow') {
        this.y = initial ? Math.random() * canvas.height : -20;
        this.speedY = (Math.random() * 0.5 + 0.2) * this.z;
        this.speedX = 0;
        this.angle = Math.random() * Math.PI * 2;
        this.size = Math.random() * 2.5 + 1;
      } 
      else if (activeSeason === 'rain') {
        this.y = initial ? Math.random() * canvas.height : -50;
        this.speedY = (Math.random() * 5 + 10) * this.z; // Very fast
        this.speedX = (Math.random() * 1 + 2); // Wind angle
        this.size = Math.random() * 15 + 10; // Line length
        this.opacity = Math.random() * 0.3 + 0.1;
      } 
      else if (activeSeason === 'autumn') {
        this.y = initial ? Math.random() * canvas.height : -30;
        this.x = Math.random() * (canvas.width + 200) - 200;
        this.speedY = (Math.random() * 1.2 + 0.8) * this.z;
        this.speedX = Math.random() * 1.5 + 0.5;
        this.size = Math.random() * 10 + 6;
        this.angle = Math.random() * Math.PI * 2;
        this.spin = (Math.random() - 0.5) * 0.05;
        this.flip = Math.random() * Math.PI; // For 3D rotation effect
        this.flipSpeed = Math.random() * 0.08 + 0.02;
        const colors = ['#8B5A2B', '#A0522D', '#5c4033', '#333333'];
        this.color = colors[Math.floor(Math.random() * colors.length)];
      } 
      else if (activeSeason === 'fire') {
        this.y = initial ? Math.random() * canvas.height : canvas.height + 20;
        this.speedY = -(Math.random() * 1.5 + 0.5) * this.z;
        this.speedX = (Math.random() - 0.5) * 1.5;
        this.size = Math.random() * 3 + 1;
        this.life = 1.0;
        this.decay = Math.random() * 0.015 + 0.005;
      }
    }

    update() {
      if (activeSeason === 'snow') {
        this.y += this.speedY;
        this.angle += 0.02;
        this.x += Math.sin(this.angle) * 0.5; // Natural swaying
        if (this.y > canvas.height + 10) this.reset();
      } 
      else if (activeSeason === 'rain') {
        this.x += this.speedX;
        this.y += this.speedY;
        if (this.y > canvas.height + 50 || this.x > canvas.width + 50) this.reset();
      } 
      else if (activeSeason === 'autumn') {
        this.x += this.speedX;
        this.y += this.speedY;
        this.angle += this.spin;
        this.flip += this.flipSpeed; 
        if (this.y > canvas.height + 20 || this.x > canvas.width + 20) this.reset();
      } 
      else if (activeSeason === 'fire') {
        this.x += this.speedX;
        this.y += this.speedY;
        this.life -= this.decay;
        if (this.life <= 0 || this.y < -10) this.reset();
      }
    }

    draw() {
      ctx.save();
      if (activeSeason === 'snow') {
        ctx.beginPath();
        ctx.fillStyle = `rgba(0, 0, 0, ${0.3 * this.z})`; 
        ctx.shadowBlur = 4;
        ctx.shadowColor = 'rgba(0,0,0,0.2)';
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      } 
      else if (activeSeason === 'rain') {
        ctx.beginPath();
        ctx.strokeStyle = `rgba(0, 0, 0, ${this.opacity})`;
        ctx.lineWidth = 1.5 * this.z;
        ctx.moveTo(this.x, this.y);
        ctx.lineTo(this.x - this.speedX * 1.5, this.y - this.speedY * 1.5); 
        ctx.stroke();
      } 
      else if (activeSeason === 'autumn') {
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.scale(Math.cos(this.flip), 1); 
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.moveTo(0, -this.size);
        ctx.bezierCurveTo(this.size, -this.size/2, this.size/2, this.size, 0, this.size);
        ctx.bezierCurveTo(-this.size/2, this.size, -this.size, -this.size/2, 0, -this.size);
        ctx.fill();
      } 
      else if (activeSeason === 'fire') {
        ctx.beginPath();
        ctx.fillStyle = `rgba(255, 69, 0, ${this.life})`; 
        ctx.shadowBlur = 10;
        ctx.shadowColor = '#ff4500';
        ctx.arc(this.x, this.y, this.size * this.life, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }
  }

  function spawnParticles() {
    particles = [];
    let count = 0;
    if (activeSeason === 'snow') count = 60;
    if (activeSeason === 'rain') count = 80;
    if (activeSeason === 'autumn') count = 25;
    if (activeSeason === 'fire') count = 50;
    
    for (let i = 0; i < count; i++) {
      particles.push(new CinematicParticle());
    }
  }
  
  spawnParticles();

  setInterval(() => {
    currentSeasonIndex = (currentSeasonIndex + 1) % seasons.length;
    activeSeason = seasons[currentSeasonIndex];
    spawnParticles();
  }, 15000);

  function render() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let p of particles) {
      p.update();
      p.draw();
    }
    requestAnimationFrame(render);
  }
  render();
}